import React, { useState } from "react";
import {
  Button,
  Divider,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Box } from "@mui/system";
import { ChevronRight } from "@mui/icons-material";
import { connect } from "react-redux";
import { gaugeActions, homeActions } from "actions";
import ShareHCPApp from "pages/home/ShareHCPApp";

const AlternativeListView = (props) => {
  const {
    alternateList,
    dislaimerText,
    zipData,
    selectedInsurance,
    onCancelAlternatives,
    onListClick,
    storeAppData,
    appQuantity,
    // saveDosage,
    // saveForm,
    // saveQuantity,
    updateLowestCouponPrice,
    organizationInfo,
  } = props;
  const theme = useTheme();
  const matchesMinWidth = useMediaQuery("(max-width:600px)");
  const [showSharePopup, setShowSharePopup] = useState(false);
  const [selectedList, setSelectedList] = useState({});
  const isHCPTemplate =
    organizationInfo?.type?.toLowerCase() === "h" &&
    organizationInfo?.app?.appCode?.toLowerCase() == "hcp";

  // useEffect(() => {
  //   return () => {
  //     saveDosage("");
  //     saveForm("");
  //     saveQuantity({});
  //   };
  // }, []);

  const onListItemClick = (item) => {
    const storedZipData = JSON.parse(localStorage.getItem("storedZipData"));
    if (item.couponType === "M") {
      updateLowestCouponPrice(item);
      onListClick({ type: "couponDetails", selectedItem: item });
    } else {
      updateLowestCouponPrice(item);
      onListClick({ type: "genericList", selectedItem: item });
    }

    if (item.couponType === "M") {
      storeAppData("brandedInfo", {
        productDetailId: item.productDetailId,
        zipCode: storedZipData?.zipCode || zipData?.zipCode,
        name: item.name,
        insuranceId: selectedInsurance.id,
        quantity: appQuantity,
        offerId: item.offerId,
      });
      storeAppData("alternate", {
        productDetailId: item.productDetailId,
        zipCode: storedZipData?.zipCode || zipData?.zipCode,
        name: item.name,
      });
    } else {
      storeAppData("alternate", {
        productDetailId: item.productDetailId,
        zipCode: storedZipData?.zipCode || zipData?.zipCode,
        name: item.name,
      });
    }
    // saveDosage(item.strength);
    // saveForm(item.dosage);
    // saveQuantity({ quantity: item.packageSize });
  };

  return (
    <>
      <Box>
        <Box mb={matchesMinWidth ? 2 : "24px"}>
          <Typography
            variant="h2LatoRegular"
            component="div"
            sx={{
              fontSize: matchesMinWidth ? "18px" : "20px",
              textAlign: "center",
            }}
          >
            {isHCPTemplate ? (
              <>
                Here are covered alternatives <br />
                for your consideration
              </>
            ) : (
              <>
                Here are covered alternatives <br />
                <b>with coupons</b> to discuss with your prescriber
              </>
            )}
          </Typography>
        </Box>
        <Divider />
        <List
          sx={{ maxHeight: "250px", overflow: "hidden", overflowY: "scroll" }}
        >
          {alternateList &&
            alternateList.map((item, index) => {
              return (
                <Box key={item.id + index}>
                  <ListItemButton
                    sx={{ paddingLeft: "1rem", paddingBottom: "1rem" }}
                    onClick={() => {
                      if (isHCPTemplate) {
                        setSelectedList(item);
                        setShowSharePopup(true);
                      } else {
                        setShowSharePopup(false);
                        setSelectedList({});
                        onListItemClick(item);
                      }
                    }}
                  >
                    <Box sx={{ width: "100%" }}>
                      <ListItemText
                        primary={item.name}
                        primaryTypographyProps={{
                          fontSize: "16px",
                          color: theme.palette.primary.main,
                          fontFamily: "Lato-Regular",
                        }}
                      />
                      <Typography
                        sx={{
                          //paddingLeft: "1.5rem",
                          fontSize: matchesMinWidth ? "12px" : "12px",
                          fontFamily: "Lato-Regular",
                          color: theme.palette.primary.main,
                          minHeight: matchesMinWidth ? 20 : 30,
                          width: "80%",
                          textAlign: "left",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          display: "inline-block",
                        }}
                      >
                        {item?.strength ? `${item?.strength}, ` : ""}
                        {item?.packageSize &&
                          `${item?.packageSize + " " + (item?.dosage || "")}`}
                      </Typography>
                    </Box>
                    <Box>
                      <Typography
                        variant="h4LatoRegular"
                        sx={{ fontSize: "15px" }}
                      >
                        {item.price}
                      </Typography>
                    </Box>
                    <ListItemIcon
                      sx={{ minWidth: matchesMinWidth ? 0 : undefined }}
                    >
                      <ChevronRight
                        sx={{ color: theme.palette.common.greenThree }}
                        fontSize="large"
                      />
                    </ListItemIcon>
                  </ListItemButton>
                  <Divider />
                </Box>
              );
            })}
        </List>
        <Box mt={matchesMinWidth ? 2 : 10} mb={3}>
          <Typography variant="h5LatoRegular">
            {dislaimerText.line1 ? `${"*" + dislaimerText.line1}` : ""}
          </Typography>
          <br />
          <Typography variant="h5LatoRegular">{dislaimerText.line2}</Typography>
        </Box>
        <Box component="div" sx={{ textAlign: "center" }} mb={5}>
          <Button
            variant="text"
            sx={{
              minWidth: matchesMinWidth ? "200px" : undefined,
              textDecoration: "underline",
            }}
            onClick={() => {
              storeAppData("brandedInfo", null);
              storeAppData("genericInfo", null);
              storeAppData("alternate", null);
              onCancelAlternatives();
            }}
          >
            CANCEL
          </Button>
        </Box>
      </Box>
      {showSharePopup && (
        <ShareHCPApp
          setShowSharePopup={setShowSharePopup}
          shareCoupon={showSharePopup}
          shareApp={false}
          couponData={selectedList}
          viewCouponLink={true}
          viewCouponLinkClick={() => {
            setShowSharePopup(false);
            onListItemClick(selectedList);
            setSelectedList({});
          }}
        />
      )}
    </>
  );
};

function mapStatetoProps(state) {
  return {
    alternateList: state.alternateList.data || [],
    dislaimerText: state.alternateList.dislaimerText,
    selectedInsurance: state.insuranceList.selectedInsurance,
    appQuantity: state.productDetails.appQuantity,
    zipData: state.zipData.data,
    organizationInfo: state.organizationInfo.data,
  };
}

const mapDispatchToProps = {
  storeAppData: (type, value) => homeActions.storeAppData(type, value),
  resetData: (value) => homeActions.resetData(value),
  saveDosage: (value) => homeActions.saveDosage(value),
  saveForm: (value) => homeActions.saveForm(value),
  saveQuantity: (value) => homeActions.saveQuantity(value),
  updateLowestCouponPrice: (param) =>
    gaugeActions.updateLowestCouponPrice(param),
};

export default connect(
  mapStatetoProps,
  mapDispatchToProps
)(AlternativeListView);
